import {Component, Input} from '@angular/core';
import {Client} from '../../client/client';
import {Categorie} from '../../dienst/categorie';
import {Taak} from '../../dienst/taak';

@Component({
    selector: 'zah-tips-header',
    templateUrl: './tips-header.component.html',
    styleUrls: ['./tips-header.component.scss'],
    standalone: false
})
export class TipsHeaderComponent {

  @Input()
  client: Client;
  @Input()
  categorie: Categorie;
  @Input()
  taak: Taak;
}
